import React, { useState, createContext } from 'react';
const DEFAULT_TAB = 0;
export const TabsContext = createContext([
    DEFAULT_TAB,
    () => { },
]);
TabsContext.displayName = 'TabsContext';
const TabsContextProvider = ({ children, defaultValue, }) => (React.createElement(TabsContext.Provider, { value: useState(defaultValue | DEFAULT_TAB) }, children));
function useTabsContext() {
    const context = React.useContext(TabsContext);
    if (context === undefined)
        throw new Error('useTabsContext must be used within a TabsContextProvider');
    return context;
}
export { TabsContextProvider, useTabsContext };
//# sourceMappingURL=TabsContext.js.map